// Taşeron portalı — Belge Analizi gelen kutusu (plan S25, `docs/plans/S25-analysis-inbox.md`
// Aşama C — C2 (tam genişlik kabuk), C3/C3b (ray + üyelik kuralı), C4 (⋯ menüsü), C12 (`X/Y
// karar verildi` göstergesi), C13 (rota) BU dosyada; C5-C12 (önizleme, çıkarılan alanlar, form,
// onay/ret, karar-sonrası odak) `AnalysisReviewPane.tsx`'te — bu sayfa yalnız o bileşenin props
// sözleşmesine göre YAZAR, iç detayına karışmaz (bkz. `AnalysisReviewPane.tsx` dosya üstü notu).
//
// **Karar-sonrası odak (C12/AC16, tasarım D10).** `handleDecided` — panelin `onDecided` prop'u —
// ray'in TÜM ağacında `findNextPendingItem` (`lib/analysisInboxTree.ts`) ile bir sonraki
// bekleyen kalemi arar ve `selectItem`i (SEÇİMİN KENDİSİ, mevcut tıklama yoluyla AYNI fonksiyon)
// çağırır — odak-taşıma İKİ YERDE ayrı ayrı YAZILMAZ. Bekleyen kalem kalmadıysa seçim temizlenir,
// panel kendi "hepsi karara bağlandı" boş durumuna düşer ve odağı KENDİ başlığına alır.
//
// **Eski sayfanın yerini alır.** `/document-analysis/:uuid`'in tek-analiz-tek-sayfa hâli
// (`DocumentAnalysisResultPage`) C14'te SİLİNDİ — canlı kalan yardımcıları (`formatPageSpan` →
// `lib/documentAnalysisPages.ts`, `computeInitialValidity` → `lib/analysisValidity.ts`) yeni
// evlerine taşındıktan SONRA. Tür listeleri o günden beri §27 kaydındadır (GL #7).
//
// **Rota (C13).** `/document-analysis` VE `/document-analysis/:uuid` AYNI bileşene açılır;
// `:uuid` yalnız hangi analizin seçili geldiğini belirler — mevcut derin bağlantılar
// (`PendingAnalysesStrip`, `DocumentAnalysisTray`) KIRILMAZ. Seçili KALEM (3. seviye ağaç
// satırı) URL'DE TAŞINMAZ, yalnız bileşen durumudur — sözleşme yalnız ANALİZ düzeyinde kalıcı
// bir bağlantı vaat eder.
//
// **Veri (plan §Veri).** Birincil kaynak `?status=awaiting-review` — `X/Y karar verildi` de
// YALNIZ bunun üzerinden sayılır (arşiv karardan SAYILMAZ, D5/A5 "etkin arşiv" zaten kararı
// tamamlanmış analizleri kapsar). Her analizin DETAYI `useQueries` ile,
// `supplierContractorKeys.analysis(companyId, uuid)` — `StrandedAnalysesStrip`'in KULLANDIĞI
// AYNI anahtar; tekilleştirme (aynı analiz iki şeritte de görünüyorsa TEK ağ isteği) buna
// bağlıdır. Arşiv listesi AYRI, istek üzerine (rayın "Arşivlenmiş analizleri yükle" düğmesi) —
// AC18: arşivlenmiş analizler varsayılan listede YOKTUR.
//
// **Sayfa boyutu + kesilme uyarısı (S25 web kod incelemesi #5).** `awaiting-review` sunucu
// varsayılanıyla (§3, `50`) çekilseydi 51. ve sonrası (`queuedAt` azalan sırada, yani EN ESKİ
// bekleyenler) rayda, `useQueries` detay kümesinde ve `findNextPendingItem`de SESSİZCE
// kaybolurdu — bu ray tam olarak bekleyen analizlerin BİRİKMESİ üzerine tasarlanmıştır. İstek
// `pageSize=200`le (§3 `MaxPageSize`, istemcinin isteyebileceği EN BÜYÜK değer) açılır; yine de
// `filteredTotal` bunu AŞARSA (`AWAITING_REVIEW_PAGE_SIZE`'dan fazla bekleyen analiz — nadir bir
// hacim), rayın ÜSTÜNDE dürüst bir "yalnız en yeni N/M gösteriliyor" uyarısı çıkar — hiçbir
// zaman TAMAMINI gösterdiğini İDDİA ETMEZ.
//
// **`active` rayı — analiz ediliyor (S25 web kod incelemesi #1).** Tepsi artık bu rotanın
// TAMAMINDA (`DocumentAnalysisTray.tsx`, `useMatch('/document-analysis/*')`) gizli — kök
// sebep düzeltmesi tepsiyi GERİ ALMAK değil, bu sayfanın UÇUŞTAKİ analizleri KENDİSİNİN
// göstermesidir: `?status=active` (`Queued`/`Running`) AYRICA çekilir ve `AnalysisInboxRail`e
// `runningAnalyses` olarak geçer — incelemek için SEÇİLEMEZ (henüz `items` yok), yalnız "Analiz
// kuyrukta"/"Analiz sürüyor" + spinner. Bu liste SUNUCU GÜDÜMLÜ yoklanır (`poll: true`,
// `pollAfterSeconds`) — istemci bir zaman aşımı İCAT ETMEZ. Bir analiz terminal olduğunda
// `active` listesinden KENDİLİĞİNDEN düşer (§20.3); aşağıdaki geçiş efekti bunu YAKALAR ve
// `awaiting-review`/`archived`'i geçersiz kılar ki `Succeeded` olan analiz normal akışa
// KAYBOLMADAN devretsin. `Failed` olan bir analiz zaten `StrandedAnalysesStrip`in (Belgeler
// sayfası) sürüp giden sorumluluğudur — burada onu ayrıca ANMAK yerine sessizce rayın dışına
// çıkması yeterlidir; kaybetmeden bir ANA sayfaya devrettiğimiz sürece bu bir REGRESYON değildir.
//
// **Kuyruk dışı derin bağlantı.** `DocumentAnalysisTray`'in "Ayrıntı" bağlantısı BAŞARISIZ
// (`Failed`) bir analiz için de görünür ve böyle bir analiz asla `awaiting-review`'da (sıfır
// kalem üretir) OLMAZ. `:uuid` bu iki listenin (awaiting-review + yüklüyse arşiv) DIŞINDA
// çözülürse rayın ÜSTÜNDE ayrı, dar bir bildirim gösterilir (Failed → hata kodu + "Yeni analiz
// başlat"; aksi → "zaten karara bağlanmış") — ray modelini sıfır kalemli bir analizi
// barındıracak şekilde ZORLAMAK yerine (rail = yalnız gerçekten karar bekleyen ağaç).

import {
  Alert,
  Breadcrumb,
  Button,
  PageHeader,
  Spinner,
  Tooltip,
  currentCulture,
  documentAnalysesApi,
  useAuthStore,
} from '@isgportal/shared';
import { useQueries, useQueryClient } from '@tanstack/react-query';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { AnalysisInboxRail } from '../components/AnalysisInboxRail';
import { AnalysisReviewPane } from '../components/AnalysisReviewPane';
import { ContractorStateNotice } from '../components/ContractorStateNotice';
import {
  countDecisions,
  findNextPendingItem,
  groupAnalysisItems,
  itemStatus,
} from '../lib/analysisInboxTree';
import { groupPagesBySource, pagesForItem } from '../lib/documentAnalysisPages';
import { supplierContractorKeys } from '../lib/supplierContractorKeys';
import { useDocumentAnalysisList } from '../lib/useDocumentAnalysis';

// #5 (S25 web kod incelemesi) — api-contract §3 `MaxPageSize`: istemcinin isteyebileceği EN
// BÜYÜK sayfa boyutu; daha büyüğü sunucuda zaten buna KIRPILIR. Sunucu varsayılanı (`50`) bu
// rayın "bekleyen analizler BİRİKİR" tasarımı için çok dardı.
const AWAITING_REVIEW_PAGE_SIZE = 200;

export function DocumentAnalysisInboxPage() {
  const { t } = useTranslation();
  const culture = currentCulture();
  const { uuid: routeUuid } = useParams<{ uuid?: string }>();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const companyId = useAuthStore((s) => s.principal?.companyId ?? null);

  const list = useDocumentAnalysisList('awaiting-review', {
    pageSize: AWAITING_REVIEW_PAGE_SIZE,
  });
  const [archivedRequested, setArchivedRequested] = useState(false);
  const archived = useDocumentAnalysisList('archived', { enabled: archivedRequested });
  // #1 (S25 web kod incelemesi) — uçuştaki (Queued/Running) analizler; dosya üstü not.
  const active = useDocumentAnalysisList('active', { poll: true });

  // Bir analiz `active`ten (terminal olduğu için) DÜŞTÜĞÜNDE (a) `awaiting-review`/`archived`i
  // geçersiz kıl — aksi hâlde `Succeeded`e ulaşan bir analiz "uçuştaki" rayından KAYBOLUR ve
  // normal akışa ancak bu iki sorgu KENDİLİĞİNDEN yeniden çekilirse (ör. sayfa yenilemesi) geri
  // döner — VE (b) o UUID'in KENDİ detay sorgusunu da geçersiz kıl: `routeUuid` ya da eski
  // `list.items` üzerinden ZATEN önbellekte duran (Queued/Running, `items: []`) anlık görüntü
  // aksi hâlde SONSUZA KADAR bayat kalır (yeni `awaiting-review` satırı "sıfır kalemli" gibi
  // render edilir, çünkü `detailsByUuid` hâlâ eski yanıtı taşır) ve deep-link'teki "kuyruk dışı"
  // uyarısı (dosya üstü not) hiç TETİKLENMEZ. `previousActiveUuidsRef` İLK render'da `null`
  // kalır (henüz karşılaştıracak bir ÖNCEKİ anlık görüntü yok — o an bir "geçiş" değil, ilk
  // yüklemedir).
  const previousActiveUuidsRef = useRef<Set<string> | null>(null);
  useEffect(() => {
    const current = new Set(active.items.map((a) => a.uuid));
    const previous = previousActiveUuidsRef.current;
    previousActiveUuidsRef.current = current;
    if (previous === null) {
      return;
    }
    const transitioned: string[] = [];
    for (const uuid of previous) {
      if (!current.has(uuid)) {
        transitioned.push(uuid);
      }
    }
    if (transitioned.length === 0) {
      return;
    }
    queryClient.invalidateQueries({
      queryKey: supplierContractorKeys.analyses(companyId, 'awaiting-review'),
    });
    queryClient.invalidateQueries({
      queryKey: supplierContractorKeys.analyses(companyId, 'archived'),
    });
    for (const uuid of transitioned) {
      queryClient.invalidateQueries({
        queryKey: supplierContractorKeys.analysis(companyId, uuid),
      });
    }
  }, [active.items, companyId, queryClient]);

  // Detay sorgulanacak uuid kümesi: birincil liste + (istenmişse) arşiv + rota'daki uuid (o
  // ikisinin DIŞINDaysa bile — "kuyruk dışı derin bağlantı", dosya üstü not). Tekilleştirme:
  // aynı uuid iki kaynakta da varsa TEK istek/TEK önbellek girdisi (Map anahtarı).
  const uuidOrder: string[] = [];
  const seenUuids = new Set<string>();
  for (const a of list.items) {
    if (!seenUuids.has(a.uuid)) {
      seenUuids.add(a.uuid);
      uuidOrder.push(a.uuid);
    }
  }
  if (archivedRequested) {
    for (const a of archived.items) {
      if (!seenUuids.has(a.uuid)) {
        seenUuids.add(a.uuid);
        uuidOrder.push(a.uuid);
      }
    }
  }
  if (routeUuid && !seenUuids.has(routeUuid)) {
    seenUuids.add(routeUuid);
    uuidOrder.push(routeUuid);
  }

  const detailQueries = useQueries({
    queries: uuidOrder.map((uuid) => ({
      // `StrandedAnalysesStrip`'in KULLANDIĞI AYNI anahtar — dedupe buna bağlı (plan §Veri).
      queryKey: supplierContractorKeys.analysis(companyId, uuid),
      queryFn: () => documentAnalysesApi.getDocumentAnalysis(uuid),
      enabled: companyId != null,
    })),
  });
  const detailsByUuid = new Map(uuidOrder.map((uuid, i) => [uuid, detailQueries[i]?.data]));
  // F4 (S25 web güvenlik incelemesi) — `error` önceden HİÇ okunmuyordu: bir 404/403 sonrası
  // `data` sonsuza kadar `undefined` kalır ve panel bunu "hâlâ yükleniyor" sanırdı. Seçili
  // analizin sorgusu HATA ile sonuçlandığında (firma değişince eski uuid artık bu kapsamda
  // çözülmüyor, ya da analiz bu arada silindi) panel bunu ayırt edebilsin diye.
  const detailErrorsByUuid = new Map(uuidOrder.map((uuid, i) => [uuid, detailQueries[i]?.error]));

  const railAnalyses = list.items.map((analysis) => ({
    analysis,
    detail: detailsByUuid.get(analysis.uuid),
  }));
  const railArchived = archivedRequested
    ? archived.items.map((analysis) => ({ analysis, detail: detailsByUuid.get(analysis.uuid) }))
    : [];

  // ---- seçim (analiz + kalem) ---------------------------------------------------------------
  const [selectedAnalysisUuid, setSelectedAnalysisUuid] = useState<string | null>(null);
  const [selectedItemUuid, setSelectedItemUuid] = useState<string | null>(null);
  const paneHeadingRef = useRef<HTMLHeadingElement>(null);
  // Rota uuid'i HANGİ değere son uygulandı — kullanıcının kendi tıklaması (`selectItem`) rotayı
  // `navigate(..., {replace:true})` ile AYNI değere taşıdığında bu ref ÖNCEDEN güncellenir; aksi
  // hâlde aşağıdaki efekt kullanıcının SEÇTİĞİ belgeyi "rota henüz uygulanmadı" sanıp o analizin
  // İLK bekleyen kalemiyle EZERdi.
  const appliedRouteUuidRef = useRef<string | null>(null);
  const routeDetail = routeUuid ? detailsByUuid.get(routeUuid) : undefined;

  // F4 — bu üç durum `companyId`ye GÖRE kapsamlanmış sorgu anahtarlarından (`analyses`/
  // `analysis`) OKUNUR, ama KENDİLERİ `companyId`ye bağlı DEĞİLDİ: firma değiştirildiğinde
  // eski `selectedAnalysisUuid`/`selectedItemUuid` (yeni firmanın ağacında YOK) ve
  // `archivedRequested` (yeni firmanın arşiv listesini gereksiz yere ister) adres çubuğunda ve
  // durumda ASILI kalırdı — detay sorgusu yeni kapsamda `404` verir, panel sonsuza kadar döner
  // (çapraz-tenant VERİ SIZINTISI değil, sıkışmış bir arayüz — her anahtar zaten `companyId`
  // taşıyor). `appliedRouteUuidRef` de sıfırlanır ki aynı `routeUuid`ye SONRADAN aynı firmada
  // geri dönülürse (örn. yanlışlıkla başka firmaya geçiş) rota yeniden UYGULANABİLSİN.
  const previousCompanyIdRef = useRef(companyId);
  useEffect(() => {
    if (previousCompanyIdRef.current === companyId) {
      return;
    }
    previousCompanyIdRef.current = companyId;
    appliedRouteUuidRef.current = null;
    setSelectedAnalysisUuid(null);
    setSelectedItemUuid(null);
    setArchivedRequested(false);
  }, [companyId]);

  useEffect(() => {
    if (!routeUuid || appliedRouteUuidRef.current === routeUuid || !routeDetail) {
      return;
    }
    appliedRouteUuidRef.current = routeUuid;
    const allItems = groupAnalysisItems(routeDetail).flatMap((g) => g.items);
    const firstPending = allItems.find((i) => itemStatus(i) === 'pending');
    const first = firstPending ?? allItems[0] ?? null;
    setSelectedAnalysisUuid(routeUuid);
    setSelectedItemUuid(first ? first.uuid : null);
  }, [routeUuid, routeDetail]);

  function selectItem(analysisUuid: string, itemUuid: string) {
    appliedRouteUuidRef.current = analysisUuid;
    setSelectedAnalysisUuid(analysisUuid);
    setSelectedItemUuid(itemUuid);
    if (analysisUuid !== routeUuid) {
      navigate(`/document-analysis/${analysisUuid}`, { replace: true });
    }
    // C12 deseni: seçimden sonra odak inceleme panelinin başlığına gider (mount-focus idiomu) —
    // `handleDecided` karar-SONRASI aynı hedefe AYNI yoldan (bu fonksiyonu çağırarak) taşır.
    requestAnimationFrame(() => paneHeadingRef.current?.focus());
  }

  // Bir sonraki bekleyen belgeye ilerlenemediğinde (hepsi karara bağlandı) seçim temizlenir —
  // panel kendi "hepsi karara bağlandı" boş durumuna düşer, odağı KENDİ başlığına alır (aynı
  // `paneHeadingRef`, `AnalysisReviewPane`'in boş-durum dalı da bunu `ref`ler).
  function clearSelection() {
    setSelectedAnalysisUuid(null);
    setSelectedItemUuid(null);
    requestAnimationFrame(() => paneHeadingRef.current?.focus());
  }

  // C12/AC16 — panelin `onDecided`i. `findNextPendingItem` ray'in TÜM ağacını (yalnız
  // `awaiting-review`, arşiv DEĞİL — arşivdeki hiçbir kalem tanım gereği `pending` olamaz)
  // düzleştirip karar VERİLEN kalemin konumundan sarılarak arar; bulursa `selectItem` (mevcut
  // tıklama yoluyla AYNI fonksiyon, aynı odak/rota davranışı) çağrılır.
  function handleDecided(analysisUuid: string, itemUuid: string) {
    const next = findNextPendingItem(railAnalyses, analysisUuid, itemUuid);
    if (next) {
      selectItem(next.analysisUuid, next.itemUuid);
    } else {
      clearSelection();
    }
  }

  const selectedDetail = selectedAnalysisUuid ? detailsByUuid.get(selectedAnalysisUuid) : undefined;
  const selection =
    selectedDetail && selectedAnalysisUuid && selectedItemUuid
      ? (() => {
          const item = selectedDetail.items.find((i) => i.uuid === selectedItemUuid);
          if (!item) {
            return null;
          }
          const group = groupAnalysisItems(selectedDetail).find((g) =>
            g.items.some((i) => i.uuid === item.uuid),
          );
          if (!group) {
            return null;
          }
          const source = item.sourceDocumentUuid
            ? selectedDetail.sources.find((s) => s.documentUuid === item.sourceDocumentUuid)
            : undefined;
          const pagesBySource = groupPagesBySource(selectedDetail.pages);
          const pages = pagesForItem(pagesBySource, item.sourceDocumentUuid, item.pages);
          return { analysisUuid: selectedAnalysisUuid, item, group, source, pages };
        })()
      : null;
  const selectedDetailError = selectedAnalysisUuid
    ? (detailErrorsByUuid.get(selectedAnalysisUuid) ?? null)
    : null;
  // F4 — hata durumu artık "yükleniyor"dan AYRIŞIR: sorgu `error` ile sonuçlandıysa `data`
  // sonsuza kadar `undefined` kalacağı için bunu görmezden gelmek panel'i kalıcı olarak
  // döndürürdü.
  const selectionLoading =
    selectedAnalysisUuid !== null && selectedDetail === undefined && !selectedDetailError;

  // ---- X/Y karar verildi (yalnız `awaiting-review` — arşiv karardan SAYILMAZ) ----------------
  let decided = 0;
  let total = 0;
  for (const entry of railAnalyses) {
    if (!entry.detail) {
      continue;
    }
    const counts = countDecisions(entry.detail.items);
    decided += counts.decided;
    total += counts.total;
  }
  const progressPercent = total > 0 ? Math.round((decided / total) * 100) : 0;
  // Panelin boş-durum kopyası bunu SEÇER ("henüz seçim yok" vs "hepsi karara bağlandı") — yalnız
  // gösterge (`decided`/`total`) tazeyken anlamlıdır; bir kararın hemen ardından bir yeniden-çekiş
  // sonuçlanana kadar bir kare eskiyebilir (zararsız — bir sonraki render kendi kendine düzelir).
  const allDecided = total > 0 && decided === total;

  // ---- kuyruk dışı derin bağlantı (dosya üstü not) --------------------------------------------
  const routeInQueue =
    routeUuid !== undefined &&
    (list.items.some((a) => a.uuid === routeUuid) ||
      railArchived.some((e) => e.analysis.uuid === routeUuid));
  const showOutOfQueueNotice =
    routeUuid !== undefined &&
    !routeInQueue &&
    routeDetail !== undefined &&
    (routeDetail.analysis.status === 'Succeeded' || routeDetail.analysis.status === 'Failed');

  // #5 (S25 web kod incelemesi) — `AWAITING_REVIEW_PAGE_SIZE`e rağmen `filteredTotal` daha
  // fazlaysa (bkz. dosya üstü not), rayın kesildiğini DÜRÜSTÇE söyle — `list.isPending`
  // sırasında (henüz `filteredTotal` gelmedi, ikisi de `0`) YANLIŞ POZİTİF vermemesi için
  // `!list.isPending` şartı.
  const truncatedNotice =
    !list.isPending && list.filteredTotal > list.items.length
      ? { shown: list.items.length, total: list.filteredTotal }
      : null;

  return (
    <div className="flex flex-col gap-4">
      <Breadcrumb
        items={[
          { label: t('documents.title'), href: '/documents' },
          { label: t('analysis.title') },
        ]}
      />
      <PageHeader
        title={t('analysis.title')}
        helperText={
          <span className="inline-flex items-center gap-1.5">
            <span>
              {t('analysis.result.disclaimerReading')} {t('analysis.result.disclaimerNotSaved')}
            </span>
            <Tooltip
              label={t('analysis.inbox.infoLabel')}
              content={t('analysis.inbox.infoContent')}
            />
          </span>
        }
        actions={
          !list.isPending && total > 0 ? (
            <div className="flex flex-col items-end gap-1">
              <span className="tnum text-sm text-muted">
                {t('analysis.inbox.progress', { decided, total })}
              </span>
              {/* Tray'in ilerleme çubuğuyla AYNI iskelet; dolgu `bg-muted`, `bg-primary` DEĞİL —
                  sayfanın tek birincil eylemi panelin `Onayla`sıdır (tasarım incelemesi §2.2). */}
              <div className="h-1 w-40 overflow-hidden bg-surface-muted" aria-hidden="true">
                <div
                  className="h-full bg-muted transition-[width] duration-150"
                  style={{ width: `${progressPercent}%` }}
                />
              </div>
              <progress
                className="sr-only"
                value={decided}
                max={total}
                aria-label={t('analysis.inbox.progress', { decided, total })}
              />
            </div>
          ) : undefined
        }
      />

      {showOutOfQueueNotice && routeDetail ? (
        routeDetail.analysis.status === 'Failed' ? (
          <Alert tone="danger">
            <div className="flex flex-col items-start gap-2">
              <p>
                {routeDetail.analysis.failureCode
                  ? t(routeDetail.analysis.failureCode, { defaultValue: t('error.generic') })
                  : t('error.generic')}
              </p>
              <Button asChild size="sm" variant="secondary">
                <Link to="/documents">{t('analysis.result.startNew')}</Link>
              </Button>
            </div>
          </Alert>
        ) : (
          <Alert tone="info">{t('analysis.inbox.outOfQueueResolved')}</Alert>
        )
      ) : null}

      {list.isPending ? (
        <div className="flex min-h-[40vh] items-center justify-center">
          <Spinner label={t('analysis.result.loading')} />
        </div>
      ) : list.error ? (
        <ContractorStateNotice error={list.error} onRetry={list.refetch} />
      ) : (
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-[20rem_1fr] xl:items-start 2xl:grid-cols-[22rem_1fr]">
          <AnalysisInboxRail
            className="xl:sticky xl:top-4 xl:max-h-[calc(100dvh-6rem)]"
            companyId={companyId}
            culture={culture}
            analyses={railAnalyses}
            archivedAnalyses={railArchived}
            selectedItemUuid={selectedItemUuid}
            selectedAnalysisUuid={selectedAnalysisUuid}
            onSelectItem={selectItem}
            archivedRequested={archivedRequested}
            archivedLoading={archivedRequested && archived.isPending}
            archivedError={archivedRequested ? archived.error : null}
            onRequestArchived={() => setArchivedRequested(true)}
            onRetryArchived={() => archived.refetch()}
            runningAnalyses={active.items}
            truncatedNotice={truncatedNotice}
          />
          <div className="min-w-0 bg-surface">
            <AnalysisReviewPane
              selection={selection}
              loading={selectionLoading}
              error={selectedDetailError}
              headingRef={paneHeadingRef}
              companyId={companyId}
              culture={culture}
              allDecided={allDecided}
              onDecided={handleDecided}
            />
          </div>
        </div>
      )}
    </div>
  );
}
